<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Tipe Barang</h5>
            </template>
            
            <label>Filter</label>
            <b-row>
                <b-col cols="12" sm="6" lg="4" class="mb-2">
                    <b-form-select id="filterInput" v-model="input.filterActive" name="filterActive" :options="statusOption">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" sm="6" lg="4" class="mb-2">
                    <multiselect v-model="input.filterJenis" name="filterJenis"
                        :options="jenisOption" :internal-search="true" :allow-empty="true"
                        deselect-label="" select-label="" label="name" track-by="id"
                        placeholder="Jenis Barang" />
                </b-col>
                <b-col cols="12" sm="6" lg="4" class="mb-2">
                    <multiselect v-model="input.filterMerk" name="filterMerk"
                        :options="merkOption" :internal-search="true" :allow-empty="true"
                        :disabled="!input.filterJenis" deselect-label="" select-label=""
                        label="name" track-by="id" placeholder="Merk Barang" />
                </b-col>
                <b-col cols="12" sm="6" lg="4" class="mb-2">
                    <b-form-input
                        v-model="input.filterName" name="filterTable"
                        type="search"
                        placeholder="Tipe Barang"
                        @keyup.enter="onFilter"
                    />
                </b-col>
                <b-col cols="12" sm="6" lg="4" class="mb-2">
                    <multiselect
                        v-model="input.filterKelompok" 
                        :options="optKelompok" 
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Kelompok Barang"
                    />
                </b-col>
            </b-row>
            <div class="d-flex flex-wrap justify-content-between align-items-center mt-1 mb-3" style="gap: 8px;">
                <div class="d-flex" style="gap: 8px;">
                    <b-button variant="pgiBtn" :disabled="isBusy" @click="onFilter">
                        <i class="fa fa-search"></i>
                    </b-button>
                    <b-button variant="pgiBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                </div>
                <div class="d-flex flex-wrap" style="gap: 8px;">
                    <b-button v-if="menu.includes('BUH')" variant="pgiBtn" name="bulkUpdateTipe" @click="bulkUpdateTipe()">Bulk Update Tipe</b-button>
                    <b-button variant="pgiBtn" name="tipeBarangAddBtn" @click="inputTipeBarang">Input Tipe Barang</b-button>
                </div>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="tipeBarang" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data tipe barang.
                </template>
                <template v-slot:cell(name)="row">
                    <p class="mb-0">{{row.item.name}}</p>
                    <p class="mb-0 smallText text-muted">
                        {{ row.item.kelompok.name || "-" }} 
                        <span style="cursor: pointer; color: #1E73BE; font-weight: bold" @click="prepareChangeKelompok(row.item)">[Ubah]</span>
                    </p>
                </template>
                <template v-slot:cell(merk.name)="row">
                    <p class="mb-0">{{row.item.merk.name}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.jenis.name}}</p>
                </template>
                <template v-slot:cell(harga)="row">
                    <div v-if="row.item.hasTahun == true">
                        <div class="text-right no-wrap">
                            Harga sesuai tahun
                        </div>
                    </div>
                    <div v-else>
                        <div class="text-right no-wrap" v-if="row.item.harga[0].harga !== null">
                            <span>RESMI Rp. {{$helper.addThousandSeparator(row.item.harga[0].harga)}} </span>           
                        </div>
                        <div class="text-right no-wrap" v-if="row.item.harga[2].harga !== null">
                            <span>LN Rp. {{$helper.addThousandSeparator(row.item.harga[1].harga)}} </span>
                        </div>
                        <div class="text-right no-wrap" v-if="row.item.harga[1].harga !== null">
                            <span>RR Rp. {{$helper.addThousandSeparator(row.item.harga[2].harga)}} </span>
                        </div>
                        <div class="d-flex justify-content-end">
                            <b-button size="sm" class="ml-2 table-button edit" v-b-tooltip.hover title="Edit Harga" name="btnEditHarga" @click="openModalEditHarga(row.item.id,row.item.jenis)">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </div>
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <div class="no-wrap">
                        <b-badge variant="success" v-if="row.item.isActive == true">AKTIF</b-badge>
                        <b-badge variant="danger" v-else>NON-AKTIF</b-badge>
                        <b-button size="sm" class="ml-2 table-button edit" v-b-tooltip.hover title="Ganti Status" name="btnEditStatus" @click="openModalEditStatus(row.item.id)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>
                    </div>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="mr-3 table-button view" v-b-tooltip.hover title="Detail" name="tipeBarangViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                        <b-link :to="`${$route.path}/${row.item.id}/edit`">
                            <b-button size="sm" class="table-button edit" v-b-tooltip.hover title="Edit" name="tipeBarangEditBtn">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-edit-harga" title="Edit Harga Tipe Barang" size="lg" no-close-on-esc no-close-on-backdrop>
            <b-form id="updateHargaForm">
                <MHarga :rincian="tipeBarang" :idTipe="this.activeEditHarga" :jenisPinjaman="activeJenisPinjaman" @hasSubmit="getTipe()"/>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>
        <b-modal id="m-edit-kelompok" title="Edit Kelompok" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div class="mb-3">
                Mengubah kelompok untuk tipe barang {{ activeItem.name }}.
            </div>
            <multiselect
                v-model="input.editKelompok" 
                :options="optKelompok" 
                :internal-search="true"
                :allow-empty="false"
                deselect-label=""
                select-label=""
                label="name"
                track-by="id"
            />
            <div class="mt-4 text-right">
                <b-button variant="pgiBtn" @click="$bvModal.show('m-confirm-edit-kelompok')">
                    Simpan
                </b-button>
            </div>
        </b-modal>
        <ModalConfirm id="m-confirm-edit-kelompok" title="Konfirmasi Ubah Kelompok" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah kelompok barang ini?" @submit="submitEditKelompok" />
        <ModalConfirm id="modal-confirm-editHarga" title="Konfirmasi Edit Harga" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah harga untuk tipe barang ini?" @submit="onUpdateHarga" />
        <ModalConfirm id="modal-confirm-editStatus" title="Konfirmasi Ubah Status Barang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah status barang ini?" @submit="onEditStatus" />
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">AKTIF</h6>
                <p class="smallText mb-0">Tipe barang ini dapat digadaikan (dimunculkan pada menu Gadai dan Simulasi).</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">NON AKTIF</h6>
                <p class="smallText mb-0">Tipe barang ini tidak dapat digadaikan (tidak dimunculkan pada menu Gadai dan Simulasi).</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="m-update-bulk" title="Bulk Update Tipe Barang Elektronik" centered no-close-on-backdrop no-close-on-esc hide-footer>
            
            <b-button variant="pgiBtn" @click="$bvModal.show('modal-confirm-download')">
                Download Template
            </b-button>
            
            <div>
                <b-alert show class="mt-4 mb-4" variant="primary">
                    <strong>Perhatian !</strong>
                    <p>Mohon untuk hanya merubah data pada kolom berwarna biru. Perubahan pada kolom lainnya tidak dibaca oleh sistem.</p>
                    <p>Bila tidak ada perubahan untuk tipe dan data tersebut, dapat dikosongkan / dibiarkan saja. jangan diisi nol atau spasi.</p>
                    <p>Untuk kolom "Upd. Approve Resmi / RR / LN", Bila terdapat isi tulisan apapun maka sistem akan menganggap tipe & spek tersebut akan diaktifkan, dan dapat diapprove di SM.</p>
                    <p>Anda dapat menghapus baris data yang tidak ada update sama sekali agar lebih tertata rapih dan mudah terlihat mana saja yang terdapat update.</p>
                </b-alert>
            </div>

            <b-form-file
                v-model="input.bulk"
                :state="Boolean(input.bulk)"
                placeholder="Input file excel..."
                drop-placeholder="Drop file here..."
                accept=".xlsx"
                class="my-2"
            ></b-form-file>
            <b-button variant="pgiBtn" @click="uploadExcel()">
                Upload Excel & Update
            </b-button>
        </b-modal>

        <ModalConfirm id="modal-confirm-download" title="Confirm Download Template Bulk" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak template bulk edit tipe barang?" @submit="openBulkDownload" />
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>

        <ModalConfirm id="confirm-update-bulk" title="Confirm Update Bulk" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengupload template bulk ini?" @submit="onSubmitBulk" />
    </div>
</template>

<script>
import MHarga from './MHarga.vue'

export default {
    name: 'master-tipe-barang',
    components: {
        MHarga
    },
    data(){
        return{
            menu: localStorage.getItem('menuChildren'),

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            isRestoringFilters: false,
            input:{
                show: 10,
                filterMerk: null,
                filterJenis: null,
                filterName: null,
                filterActive: null,
                filterKelompok: null,
                sortBy: null,
                sortDesc: null,
                hargaBarangBaruResmi: null,
                hargaBarangBaruLN: null,
                hargaBarangBaruRR: null,
                editKelompok: null,
                bulk:null
            },
            fields: [
                { key: "name", label: "Tipe Barang / Kelompok", sortable:true },
                { key: "merk.name", label: "Merk Barang", sortable:true },
                { key: "harga", label: "Harga", sortable:true },
                { key: "status", label: "Status"},
                { key: "action", label: "Aksi" }
            ],
            filter: null,
            tipeBarang: [],
            activeItem: {},
            activeJenisPinjaman:null,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'}, 
                { value: 50, text: '50'},
            ],
            statusOption: [
                {value: true, text:"Aktif"},
                {value: false, text:"Non Aktif"}
            ],
            merkOption: [],
            jenisOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",
            singleDataHarga: {},
            activeEditHarga: null,
            activeEditStatus: null,

            optKelompok: [],

            isLoading: false,
            filePathDownload: "",
        }
    }, 

    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            
            if(sessionStorage.getItem("page_tipe") != null || sessionStorage.getItem("page_tipe") != undefined){
                this.query = this.query + "&page=" + sessionStorage.getItem("page_tipe")
                this.page = parseInt(sessionStorage.getItem("page_tipe")) 
            }
            if(sessionStorage.getItem("currentPage_tipe") != null || sessionStorage.getItem("currentPage_tipe") != undefined){
                // this.query = this.query + "&page=" + sessionStorage.getItem("currentPage_tipe")
                this.currentPage = parseInt(sessionStorage.getItem("currentPage_tipe")) 
            }
            if(sessionStorage.getItem("size_tipe") != null || sessionStorage.getItem("size_tipe") != undefined){
                // this.query = this.query + "&page=" + sessionStorage.getItem("size_tipe")
                this.size = parseInt(sessionStorage.getItem("size_tipe")) 
                this.input.show = parseInt(sessionStorage.getItem("size_tipe")) 
            }
            if(sessionStorage.getItem("filterActive_tipe") != null || sessionStorage.getItem("filterActive_tipe") != undefined){
                this.query = this.query + "&filterActive=" + sessionStorage.getItem("filterActive_tipe")
                this.input.filterActive = sessionStorage.getItem("filterActive_tipe")
            }
            const storedJenisId = sessionStorage.getItem("filterJenis_tipe")
            const storedMerkId = sessionStorage.getItem("filterMerk_tipe")
            if(storedJenisId != null){
                this.query = this.query + "&filterJenis=" + storedJenisId
            }
            if(storedMerkId != null){
                this.query = this.query + "&filterMerk=" + storedMerkId
            }
            if (sessionStorage.getItem("filterName_tipe") != null || sessionStorage.getItem("filterName_tipe") != undefined) {
                const filterNameFromStorage = sessionStorage.getItem("filterName_tipe");
                const filterName = encodeURIComponent(filterNameFromStorage);
                this.query = this.query + "&filterName=" + filterName;
                this.input.filterName = sessionStorage.getItem("filterName_tipe") 
            }
            if(sessionStorage.getItem("filterKelompok_tipe") != null || sessionStorage.getItem("filterKelompok_tipe") != undefined){
                this.query = this.query + "&filterKelompok=" + JSON.parse(sessionStorage.getItem("filterKelompok_tipe")).id
                this.input.filterKelompok = JSON.parse(sessionStorage.getItem("filterKelompok_tipe"))
            }

            let getJenisBarang = this.$axios.get("barang-jenis/").then(async response => {
                this.jenisOption = response.data
                if(storedJenisId != null) {
                    this.isRestoringFilters = true
                    this.input.filterJenis = this.jenisOption.find(item => item.id == storedJenisId) || null
                    if(this.input.filterJenis != null) {
                        const merkResponse = await this.$axios.get(`barang-merk/jenis/${storedJenisId}`)
                        this.merkOption = merkResponse.data
                        this.input.filterMerk = this.merkOption.find(item => item.id == storedMerkId) || null
                    }
                    this.isRestoringFilters = false
                }
            })

            let getTipe = this.$axios.get("barang-tipe-v2/"+this.query).then(response => {
                this.tipeBarang = response.data.data
                this.updateTotalItem(response.data.total)
            })

            let getKelompokBarang = this.$axios.get("barang-kelompok/selection").then(res => {
                this.optKelompok = res.data
                this.optKelompok.unshift({ id: 0, name: "Tidak ada kelompok" })
            })

            Promise.all([getJenisBarang, getTipe, getKelompokBarang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        prepareChangeKelompok(item) {

            this.activeItem = item
            if(item.kelompok.name == null) {
                this.input.editKelompok = { id: 0, name: "Tidak ada kelompok" }
            }
            else {
                this.input.editKelompok = item.kelompok
            }

            this.$bvModal.show("m-edit-kelompok")

        },

        submitEditKelompok() {

            let payload = new FormData()
            payload.append("tipeId", this.activeItem.id)
            payload.append("kelompokId", this.input.editKelompok.id)

            this.isSubmitting = true
            this.$axios.post("barang-tipe-v2/edit-kelompok", payload).then(res => {

                this.$helper.toastSucc(this, "Kelompok barang berhasil diubah!")
                this.$bvModal.hide("m-edit-kelompok")
                this.$bvModal.hide("m-confirm-edit-kelompok")

                this.getTipe()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },
        
        //----------------- Fungsi Ambil Data Tipe -----------------

        getTipe(){
            this.toggleBusy()
            this.tipeBarang = []
            
            if (this.input.filterActive != null){
                this.query = this.query + "&filterActive=" + this.input.filterActive
                sessionStorage.setItem("filterActive_tipe", this.input.filterActive);
            } 
            if (this.input.filterJenis != null) {
                this.query = this.query + "&filterJenis=" + this.input.filterJenis.id
                sessionStorage.setItem("filterJenis_tipe", this.input.filterJenis.id);
            }
            if (this.input.filterMerk != null){
                this.query = this.query + "&filterMerk=" + this.input.filterMerk.id
                sessionStorage.setItem("filterMerk_tipe", this.input.filterMerk.id);
            } 
            if (this.input.filterName != null) {
                const filterName = encodeURIComponent(this.input.filterName);
                this.query = this.query + "&filterName=" + filterName;
                sessionStorage.setItem("filterName_tipe", this.input.filterName);
            } 
            if (this.input.filterKelompok != null) {
                this.query = this.query + "&filterKelompok=" + this.input.filterKelompok.id
                sessionStorage.setItem("filterKelompok_tipe", JSON.stringify(this.input.filterKelompok));
            } 
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.$axios.get("barang-tipe-v2/"+this.query).then(response => {
                this.tipeBarang = response.data.data
                if (this.isBusy == true) this.isBusy = false
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getTipe()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                sessionStorage.setItem("page_tipe", this.page);
                sessionStorage.setItem("currentPage_tipe", this.currentPage);
                sessionStorage.setItem("size_tipe", this.size);
                this.getTipe()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy == "merk.name"){
                this.input.sortBy = "merk"
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }else if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            // sessionStorage.removeItem('filterActive_tipe')
            // sessionStorage.removeItem('filterJenis_tipe')
            // sessionStorage.removeItem('filterMerk_tipe')
            // sessionStorage.removeItem('filterName_tipe')
            // sessionStorage.removeItem('filterKelompok_tipe')
            sessionStorage.clear()
            
            this.input.filterActive = null
            this.input.filterJenis = null
            this.input.filterName = null
            this.input.filterMerk = null
            this.input.filterKelompok = null
            this.merkOption = []
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getTipe()
        },

        onFilter(){
            if (this.input.filterJenis != null && this.input.filterMerk == null) {
                this.$helper.toastErr(this, "Filter tidak dapat dilakukan dengan jenis barang sendiri, harus bersama merk barang!")
            } 
            else {
                this.page = 0
                this.currentPage = 1
                this.query = this.$helper.makeQuery(0, this.size)
                this.loading = true
                this.getTipe()
            }
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputTipeBarang(){
            this.$router.push({path: `${this.$route.path}/input`});
        },

        openModalEditHarga(id,jenisPinjaman){
            this.activeEditHarga = id
            this.activeJenisPinjaman = jenisPinjaman
            this.$bvModal.show("modal-edit-harga")
        },

        openModalConfirmEditHarga(){
            if (this.input.hargaBarangBaruResmi === "") {
               return this.$helper.toastErr(this, "Harga barang tidak bisa kosong")
            } 
            if (this.input.hargaBarangBaruLN === "") {
               return this.$helper.toastErr(this, "Harga barang tidak bisa kosong")
            } 
            if (this.input.hargaBarangBaruRR === "") {
               return this.$helper.toastErr(this, "Harga barang tidak bisa kosong")
            } 
            
            this.$bvModal.show("modal-confirm-editHarga")
        },

        openModalEditStatus(id){
            this.activeEditStatus = id
            this.$bvModal.show("modal-confirm-editStatus")
        },

        onUpdateHarga(){
            let payload = new FormData()

            let nominal = this.$helper.removeThousandSeparator(this.input.hargaBarangBaru)
            
            //----------------- Append Data -----------------

            payload.append("tipeId", this.activeEditHarga)
            payload.append("newPrice", nominal)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            this.$axios.post("barang-tipe-v2/edit-price/", payload).then(response => {
                let idx = this.tipeBarang.findIndex(item => item.id == this.activeEditHarga);
                this.tipeBarang[idx].harga = nominal
                this.$bvModal.hide("modal-edit-harga")
                this.$bvModal.hide("modal-confirm-editHarga")
                this.$helper.toastSucc(this, "Harga Barang berhasil diubah!")

            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        onEditStatus(){
            let payload = new FormData()
            
            //----------------- Append Data -----------------

            payload.append("tipeId", this.activeEditStatus)

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            this.$axios.post("barang-tipe-v2/switch-is-active", payload).then(response => {
                let idx = this.tipeBarang.findIndex(item => item.id == this.activeEditStatus);
                if (this.tipeBarang[idx].isActive == true) this.tipeBarang[idx].isActive = false
                else this.tipeBarang[idx].isActive = true
                this.$bvModal.hide("modal-confirm-editStatus")
                this.$helper.toastSucc(this, "Status Barang berhasil diubah!")

            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        bulkUpdateTipe(){
            this.input.bulk = null
            this.$bvModal.show('m-update-bulk')
        },

        openBulkDownload() {
            this.showWebLaporan = false
            this.isLoading = true
            this.isSubmitting = true
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-confirm-download')
            setTimeout(() => { this.axiosBulkDownload() }, 500)
        },

        axiosBulkDownload(){ 
                this.$axios.get(`barang-tipe-v2/download-excel-bulk-update`).then(response => {
                    this.filePathDownload = response.data.name
                
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$bvModal.hide('modal-download-excel')
                    this.$helper.toastErr(this, error.response.data.reason)
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.isLoading = false
                })
            },

            uploadExcel(){
                if (this.input.bulk == null) {
                    return  this.$helper.toastErr(this, "Mohon Update File Template terlebih dahulu!")
                }

                this.$bvModal.show('confirm-update-bulk')
            },

            onSubmitBulk(){
            
                let payload = new FormData()
            payload.append("file", this.input.bulk)
      
            this.isSubmitting = true
                this.$axios.post(`barang-tipe-v2/bulk-update-harga`, payload).then(response => {
                  
                    this.$bvModal.hide('confirm-update-bulk')
                    this.$helper.toastSucc(this, "Template Bulk Telah Diupload!")
                    this.input.bulk = null
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$bvModal.hide('confirm-update-bulk')
                    this.$helper.toastErr(this, error.response.data.reason)
                    this.isSubmitting = false
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.isLoading = false
                })
            }
    },

    watch:{

         //----------------- Pantau Filter Jenis Barang -----------------
         
        'input.filterJenis': function(jenis){
            if(this.isRestoringFilters) return
            if(this.input.filterJenis != null){
                this.$axios.get(`barang-merk/jenis/${jenis.id}`).then(response => {
                    this.merkOption = response.data
                    this.input.filterMerk = null
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            } else {
                this.merkOption = []
                this.input.filterMerk = null
            }
        },

        "input.hargaBarangBaru": function(newValue) {
            if(this.input.hargaBarangBaru != 0){
                let cleanValue = this.$helper.changeToValue(newValue)
                const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                this.$nextTick(() => this.input.hargaBarangBaru = result)
            }
        },
    },

    created(){
        this.init()
    }
}
</script>
